import VendorDetailsContainer from "./VendorDetailsContainer";
import VendorDetailsStore from "./VendorDetailsStore";
export default VendorDetailsStore(VendorDetailsContainer); 